import { initialQuoteState } from '../../data/quote-data';
import { IQuoteModel } from '../../models/create-quote/quote.interface';
import { createStore } from '../store';

export const {
  Provider: QuoteProvider,
  useStore,
  useSetStore
} = createStore<IQuoteModel>(initialQuoteState);
